module.exports = __webpack_public_path__ + "media/images/location-icon-e2cc7c13c593c6ef5937ec8aca494e4e.svg";